import { useTranslation } from "react-i18next";
import "./style.css";
import { VStack } from "components/Stack";
import Button from "components/ui/Button";
import Card from "components/ui/Card";
import finishSetup from "images/finish_setup.svg";

type Props = {
  onClick: () => void;
};

function FinishSetup(props: Props) {
  const { t } = useTranslation();

  return (
    <Card className={"finish-container"}>
      <VStack align={"center"}>
        <img src={finishSetup} alt="" />

        <div className={"finish-setup-content"}>
          {t("Learn.finishSetup.recommendedCourses")}
        </div>

        <Button onClick={props.onClick}>{t("Learn.finishSetup.action")}</Button>
      </VStack>
    </Card>
  );
}

export default FinishSetup;
